var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258.501,
    height: 190.955,
    viewBox: "0 0 258.501 190.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(-1093.75 -1616.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 258.501,
    height: 137.235,
    rx: 46,
    transform: "translate(1093.75 1658.765)",
    fill: "#f5fafd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "copy_2_",
    "data-name": "copy (2)",
    transform: "translate(1143.314 1618.006) rotate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M80.19,0H14.768A14.811,14.811,0,0,0,0,14.768V101.6a14.812,14.812,0,0,0,14.768,14.768H80.19A14.78,14.78,0,0,0,94.958,101.6V14.768A14.78,14.78,0,0,0,80.19,0Z",
    transform: "translate(21.52 21.463)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M84.452,4.923A4.921,4.921,0,0,0,79.529,0H15.41A15.427,15.427,0,0,0,0,15.41v85.538a4.923,4.923,0,0,0,9.845,0V15.41A5.571,5.571,0,0,1,15.41,9.845H79.529a4.921,4.921,0,0,0,4.923-4.923Z",
    transform: "translate(0 0)",
    fill: "#4397d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "click",
    transform: "translate(1191.191 1732.118) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M0,7.777a6.246,6.246,0,0,0,6.239,6.239H33.853a6.246,6.246,0,0,0,6.239-6.239V0H0Z",
    transform: "translate(19.227 111.799)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M72.406,72.525a12.1,12.1,0,0,0,2.568-7.437V55.337a12.117,12.117,0,0,0-8.682-11.574L43.129,37.012V9.943a9.943,9.943,0,1,0-19.886,0V53.391L16.11,44.832A9.106,9.106,0,0,0,.692,54.125q.027.067.059.131L16.971,87h45.56Z",
    transform: "translate(0 16.556)",
    fill: "#4397d2",
    stroke: "#f5fafd",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M26.217,0A26.247,26.247,0,0,0,0,26.217a4.123,4.123,0,0,0,8.247,0,17.97,17.97,0,0,1,35.941,0,4.123,4.123,0,1,0,8.247,0A26.247,26.247,0,0,0,26.217,0Z",
    transform: "translate(6.969 0)",
    fill: "#fff",
    stroke: "#4397d2",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "film",
    d: "M11.939,0H.36A.36.36,0,0,0,0,.36V9.908a.36.36,0,0,0,.36.36H11.939a.36.36,0,0,0,.36-.36V.36A.36.36,0,0,0,11.939,0ZM4.625,6.344V3.924a.463.463,0,0,1,.258-.412.511.511,0,0,1,.507.027l2.062,1.2.03.02a.455.455,0,0,1,0,.742l-.03.02L5.39,6.729a.511.511,0,0,1-.507.027.462.462,0,0,1-.258-.412Zm3.836-5V.721H9.671v.627Zm-.721,0H6.532V.721H7.741Zm-1.93,0H4.6V.721H5.811Zm-1.93,0H2.672V.721H3.881Zm0,7.572v.627H2.672V8.92Zm.721,0H5.811v.627H4.6Zm1.93,0H7.741v.627H6.532Zm1.93,0H9.671v.627H8.461Zm3.117-7.572H10.391V.721h1.188ZM1.951.721v.627H.721V.721ZM.721,8.92H1.951v.627H.721Zm9.671.627V8.92h1.188v.627Zm0,0",
    transform: "translate(1196.936 1688.017) rotate(-2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "image_2_",
    "data-name": "image (2)",
    transform: "translate(1210.336 1687.239) rotate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M2.364,1.182A1.182,1.182,0,1,1,1.182,0,1.182,1.182,0,0,1,2.364,1.182Zm0,0",
    transform: "translate(1.773 1.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M12.409,0H1.773A1.775,1.775,0,0,0,0,1.773V8.863c0,.033.008.064.01.1a.436.436,0,0,0,.021.21,1.772,1.772,0,0,0,1.741,1.465H12.409a1.775,1.775,0,0,0,1.773-1.773V1.773A1.775,1.775,0,0,0,12.409,0ZM1.773,1.182H12.409A.592.592,0,0,1,13,1.773V6.464L9.891,3.356a1.037,1.037,0,0,0-1.465,0L5.613,6.168l-.745-.744a1.037,1.037,0,0,0-1.465,0L1.182,7.645V1.773a.592.592,0,0,1,.591-.591Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Aa",
    transform: "translate(1189.076 1681.001) rotate(-1)",
    fill: "#fff",
    fontSize: 29,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Aa")))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.2990eb76c0f211bc00e8eef0be7d5be3.svg";
export { ForwardRef as ReactComponent };